import React from "react";
import { Alert, Button, Space, Spin } from "antd";
import { connect } from "react-redux";
import { userSignOut } from "actions/Auth";
import { connectionSession, startConnectionSession } from "../../app/connectionSession";

export function ConnectionGate({ children, path, userSignOut: signOut }) {
  const [session, setSession] = React.useState(connectionSession.state);
  React.useEffect(() => {
    const unsubscribe = connectionSession.subscribe(setSession);
    const stop = startConnectionSession();
    return () => { unsubscribe(); stop(); };
  }, []);
  // Account management stays reachable when a plan has zero slots or is full.
  const management = /^\/(signin|signup)$/.test(path) ||
    /^\/app\/inicio\/(suscripcion|register|new-subscription|success(?:-regalo|-testudo)?)\/?$/.test(path);
  if (management || session.status === "anonymous" || session.status === "allowed") return children;
  const checking = session.status === "checking";
  const text = session.status === "full"
    ? session.limit === 0
      ? "Tu plan no dispone de conexiones para acceder al contenido. Puedes revisar o contratar un plan desde Mi suscripción."
      : `Tu plan permite ${session.limit} ${session.limit === 1 ? "conexión simultánea y ya está ocupada" : "conexiones simultáneas y están ocupadas"}. Cierra sesión en otra pestaña o dispositivo y vuelve a intentarlo.`
    : session.status === "auth" ? "Tu sesión ha caducado o ha cambiado la contraseña. Vuelve a iniciar sesión."
    : "No podemos comprobar tu conexión. Revisa tu conexión a Internet y vuelve a intentarlo.";
  return <div style={{ maxWidth: 600, margin: "60px auto", padding: 24 }}>
    <h1>{checking ? "Comprobando tu conexión" : "No se puede abrir otra conexión"}</h1>
    {connectionSession.user && connectionSession.user.email && <p>Cuenta vinculada: <strong>{connectionSession.user.email}</strong></p>}
    {checking ? <Spin /> : <Alert message={text} type={session.status === "full" ? "warning" : "error"} showIcon />}
    <Space direction="vertical" style={{ width: "100%", marginTop: 24 }}>
      <Button block type="primary" onClick={() => connectionSession.resume()}>Reintentar</Button>
      <Button block href="/#/app/inicio/suscripcion">Mi suscripción</Button>
      <Button block onClick={async () => { await connectionSession.leave(); signOut(); }}>Cerrar sesión</Button>
    </Space>
  </div>;
}
export default connect(null, { userSignOut })(ConnectionGate);



// WEBPACK FOOTER //
// ./components/ConnectionGate/index.js